<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: 'Feature' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه ویژگی ها
        </b-button
        >
      </router-link>
    </b-col>

    <form @submit.prevent>

      <div class="row">

        <form-group class="col-lg-4" :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام</label>

            <input v-model="form.name" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="col-lg-4" :validations="$v.form.public_name">
          <div slot-scope="{ errors, invalid }">
            <label>نام عمومی</label>
            <input v-model="form.public_name" type="text" class="form-control">
            <form-errors-manager :errors="errors"/>
          </div>

        </form-group>

        <form-group class="col-lg-4" :validations="$v.form.order">
          <div slot-scope="{ errors, invalid }">
            <label>ترتیب</label>
            <input v-model="form.order" type="text" class="form-control">
            <form-errors-manager :errors="errors"/>
          </div>

        </form-group>

      </div>
      <b-row align-h="center" align-v="center">
        <div class="col-lg-6">
          <languageBox class="my-5 " v-model="form.language_id" :validation="$v.form.language_id"/>
        </div>
        <div class="col-lg-6">


          <form-group class="col text-right Font" :validations="$v.form.featureImagePreview">
            <div slot-scope="{ errors, invalid }">


              <div id="featureImagePreview" class="my-2 text-center">
                <img alt="" v-if="form.featureImagePreview" width="300" height="300" :src="form.featureImagePreview"/>
              </div>

              <b-form-file
                  browse-text="انتخاب عکس"
                  @change="onFileChange"
                  class="text-center"
                  v-model="form.featureImage"
                  placeholder="انتخاب عکس"
                  drop-placeholder="انتخاب عکس"
              ></b-form-file>

              <span class="btn btn-danger" v-if="featureImageStatus()" @click="removeFeatureImage()">حذف عکس</span>

              <input id="feature-image" type="hidden" @change="onFileChange"/>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


        </div>


      </b-row>

      <div class="row pt-3">

        <div class="col-lg-6">
          <form-group :validations="$v.form.type">
            <div slot-scope="{ errors, invalid }">
              <label>نوع</label>
              <div>
                <b-form-select v-model="form.type" :disabled="pageStatus" :options="featureTypes"></b-form-select>
              </div>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div class="col-lg-6">
          <form-group :validations="$v.form.feature_attributes">
            <div slot-scope="{ errors, invalid }">
              <label>خصوصیات ویژگی</label>
              <div class="">

                <div class="" v-if="['checkbox-step','list-step'].indexOf(form.type) > -1">


                  <b-button class="my-1" pill v-b-modal.feature-attribute-adding>اضافه کردن جمعی</b-button>

                  <b-modal id="feature-attribute-adding" hide-footer>
                    <div class="text-right" dir="rtl">

                      <form @submit.prevent="submitFeatureAttributeBatching">
                        <div class="form-group">
                          <label for="from-feature-attribute-content">ویژگی ها</label>
                          <textarea required class="form-control" id="from-feature-attribute-content" rows="3"
                                    v-model="formAttributeBatching"></textarea>
                        </div>
                        <div class="text-center">
                          <button type="submit" class="btn btn-primary">ثبت</button>
                        </div>
                      </form>


                    </div>
                  </b-modal>


                </div>

                <b-input-group dir="ltr">
                  <date-picker v-if="form.type==='date'" clearable auto-submit v-model="feature_attributes"
                               placeholder="انتخاب تاریخ"
                               format="YYYY-MM-DD" display-format="jYYYY/jM/jD"/>

                  <b-form-input dir="rtl" v-else class="text-right" v-model="feature_attributes"
                                @keyup.enter="addItem"></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addItem" type="button" variant="info">اضافه کردن</b-button>
                  </b-input-group-append>
                </b-input-group>

                <div class="items">
                  <div class="item mt-2" v-for="(item, index) in form.feature_attributes" :key="index">
                    <feature-attribute :feature="form" :feature-index="index" :item="item"
                                       @removeFeatureAttribute="removeItem"/>
                  </div>
                </div>

              </div>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <p v-if="unFilteredFeatureTypes.indexOf(form.type) === -1">تیک جلوی ویژگی باعث اضافه شدن آن به فیلتر های
          ارشیو محصول میشود.</p>
      </div>

      <b-col class="text-center">
        <b-btn variant="purple" pill @click="onSubmit" class=" col-lg-8 my-5 ">
          ثبت
        </b-btn>
      </b-col>

    </form>
  </b-container>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import FormGroup from "../../validator/FormGroup";
import {required, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import router from "@/router";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import languageBox from "../Language/LanguageBox";
import FeatureAttribute from "./components/FeatureAttribute.vue";
import {featureTypes} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature";
import {checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {unFilteredFeatureTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature'

export default {
  name: "CreateFeatureForm",
  components: {FeatureAttribute, FormGroup, FormErrorsManager, languageBox, datePicker: VuePersianDatetimePicker,},
  data() {
    return {
      unFilteredFeatureTypes,
      feature_attributes: '',
      featureTypes,
      form: {
        id: '',
        name: '',
        public_name: '',
        type: 'text',
        feature_attributes: [],
        language_id: '',
        featureImage: [],
        featureImagePreview: '',
        order: 1,
      },
      formAttributeBatching: ''
    }
  },
  props: ['functionType', 'title'],
  validations: {
    form: {
      name: {required},
      public_name: {required},
      type: {required},
      feature_attributes: {required},
      language_id: {required},
      featureImagePreview: {},
      order: {required, numeric},
    },
  },
  computed: {
    pageStatus() {
      // below condition define we are in update mode or not
      return router.currentRoute.params.id !== undefined
    }
  },
  methods: {
    checkValueIsNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async onSubmit() {
      if (this.invalid()) {
        let form = Object.assign({}, this.form)

        if (this.functionType === 'update') {
          await this.$store.dispatch('Feature/updateFeature', form)
        } else {
          await this.$store.dispatch('Feature/createFeature', form);
        }

        await this.initComponent(false)

      }
    },
    addItem() {
      if (this.feature_attributes.trim().length === 0) {
        return
      }
      if ((this.form.type == 'text' || this.form.type == 'link') && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی مورد نظر بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.form.type == 'number' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "عدد" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.form.type == 'date' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "تاریخ" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.form.type == 'switch' && this.form.feature_attributes.length == 2) {
        toast('خطا', 'برای ویژگی های "دوحالته" بیشتر از دو مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.form.type == 'variable' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "متغییر" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.form.type == 'formula' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "فرمول" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }


      this.form.feature_attributes.push({value: this.feature_attributes, filterable: 0})

      this.feature_attributes = ''

    },
    removeItem(index) {

      if (this.checkValueIsNumber(this.form.feature_attributes[index].id)) {
        const feature_attribute = this.form.feature_attributes[index];
        const form = {
          feature_attribute_id: feature_attribute.id,
        }
        this.$store.dispatch('Feature/removeFeatureAttribute', form)
      }
      this.form.feature_attributes.splice(index, 1)
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.featureImage = file;
      this.form.featureImagePreview = URL.createObjectURL(file);
    },
    removeFeatureImage() {
      if (confirm('از حذف عکس اطمینان دارید؟')) {
        // in create mode we make image empty and in update mode we request to server to make it remove
        if (this.pageStatus) {
          this.$store.dispatch('Feature/removeFeatureImage', this.form).then(res => {
            this.form.featureImagePreview = '';
            this.form.featureImage = [];
          })
        } else {
          this.form.featureImagePreview = '';
          this.form.featureImage = [];
        }
      }
      this.$forceUpdate()
    },
    featureImageStatus() {
      return this.form.featureImagePreview != null
    },
    async initComponent() {
      if (this.pageStatus) {
        this.form.id = router.currentRoute.params.id;
        const form = this.form
        this.$store.dispatch('Feature/getFeature', form).then(async res => {
          let feature = res.data.data
          this.form.type = await feature.type
          this.form.name = await feature.name
          this.form.featureImagePreview = await feature.image
          this.form.language_id = await feature.language_id
          this.form.public_name = await feature.public_name
          this.form.order = await feature.order

          this.form.feature_attributes = await feature.feature_attributes
          this.form.feature_attributes.forEach(item => {
            item.featureImagePreview = item.image
            item.image = [];
          })
          document.getElementById(`language_item_${this.form.language_id}`).click();
        }).catch(err => {
          console.log(err)
          router.push({name: 'Feature'})
        })

      }
    },
    submitFeatureAttributeBatching() {

      let tempFeature = this.formAttributeBatching
      tempFeature = tempFeature.split(',')


      let featureAttributeNames = this.form.feature_attributes.map(item => item.name)

      tempFeature.forEach(item => {
        if (featureAttributeNames.indexOf(item) == -1) {
          this.form.feature_attributes.push({"value": item, "filterable": 0})
        }
      })

      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')


    }
  },
  async mounted() {
    await this.initComponent()
    await this.$store.commit("Feature/setFilters", {key: "item_type", value: 'variable'})
    await this.$store.dispatch("Feature/getFeatures");
  },
  destroyed() {
    this.$store.commit("Feature/setFilters", {key: "item_type", value: ''})
  }
};

</script>

<style scoped>
#featureImagePreview img {
  object-fit: contain;
  width: 250px;
  height: 250px;
}
</style>